export enum DictType {
  Units = 'units',
  FederalRegions = 'federalRegions',
  EconomicRegions = 'economicRegions',
  TypeDwellings = 'type-dwellings',
  TypeRuleToLands = 'type-rule-to-lands',
  TypePermittedUseLands = 'type-permitted-use-lands',
  ReasonForOpening = 'reason-for-opening',
  DocumentsOnAvailableRights = 'documents-on-available-rights',
  TypeMachineryEquipments = 'type-machinery-equipments',
  TypeStateSupports = 'type-state-supports',
  TypeLivestockProducts = 'type-livestock-products',
  TypeFarmAnimals = 'type-farm-animals',
  TypeSpoks = 'type-spoks',
  TypeAgriculturalCrops = 'type-agricultural-crops',
  PlantedPreviousYears = 'planted-previous-years',
  OtherEquipments = 'other-equipments',
  OtherLivestockProducts = 'other-livestock-products',
  OtherFarmAnimals = 'other-farm-animals',
  LandCategories = 'land-categories',
  PlantedBerryCrops = 'planted-berry-crops',
  RelationToHeads = 'relation-to-heads',
  Genders = 'genders',
  TypeLands = 'type-lands',
  IdentityDocuments = 'identity-documents',
}
